import { createStore } from 'redux'
import reducers from './functions/reducers'

export default createStore(reducers)